import React from 'react';
import ReactDOM from 'react-dom';
import './global.css';
import AppProvider from './AppProvider';
// import "@babel/polyfill";
import "core-js/stable";
import "regenerator-runtime/runtime";
import * as serviceWorker from './serviceWorker';
import { setInitialTitle } from './app/util/titleManager';

// Set initial title
setInitialTitle();

const rootElement = document.getElementById('root');
ReactDOM.render(<AppProvider />, rootElement);

if (module.hot) {
	module.hot.accept('./AppProvider', () => {
		const NextAppProvider = require('./AppProvider').default
		ReactDOM.render(
			<NextAppProvider />,
			rootElement
		)
	})
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
